/**
 * @mixin
 */
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            default: ""
        },
        checked: {
            default: null
        },
        modelObject: {
            type: Object,
            default: null
        },
        trueValue: {
            default: true
        },
        falseValue: {
            default: false
        },
        editable: {
            type: Boolean,
            default: true
        }
    }
}
